(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[32809],{

/***/ 32809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_CollapseItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Typography/utils/useTypography.js
var useTypography = __webpack_require__(18422);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./UI/components/CollapseItem/utils/useCollapseItem.js

var useCollapseItem = function(param) {
    var faq = param.faq;
    var ref = (0,react.useState)(false), isAnswerOpened = ref[0], setIsAnswerOpened = ref[1];
    var handleOnQuestionClick = function() {
        return setIsAnswerOpened(function(prevState) {
            return !prevState;
        });
    };
    return {
        faq: faq,
        isAnswerOpened: isAnswerOpened,
        handleOnQuestionClick: handleOnQuestionClick
    };
};

// EXTERNAL MODULE: ./UI/components/CollapseItem/styles.module.scss
var styles_module = __webpack_require__(94373);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/CollapseItem/index.jsx













var Animated = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var CollapseItem = function(_param) {
    var type = _param.type, props = (0,_object_without_properties/* default */.Z)(_param, [
        "type"
    ]);
    var ref = useCollapseItem(props), isAnswerOpened = ref.isAnswerOpened, handleOnQuestionClick = ref.handleOnQuestionClick, faq = ref.faq;
    if (isEmpty_default()(faq)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((styles_module_default()).questionContainer, (styles_module_default())[type]),
        onClick: handleOnQuestionClick,
        role: "button",
        tabIndex: "0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).question,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                        isBold: true,
                        size: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                        variant: "p",
                        className: (styles_module_default()).questionTitle,
                        children: faq.question
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((styles_module_default()).plus, (0,_define_property/* default */.Z)({}, (styles_module_default()).minus, isAnswerOpened)),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).answerWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Animated, {
                    type: constants/* ANIMATED_TYPE.expandByHeight */.BK.expandByHeight,
                    open: isAnswerOpened,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                            className: (styles_module_default()).answer,
                            children: faq.answer
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                            document: faq.longAnswer
                        })
                    ]
                })
            })
        ]
    });
};
CollapseItem.defaultProps = {
    faq: {}
};
CollapseItem.propTypes = {
    faq: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_CollapseItem = (CollapseItem);


/***/ }),

/***/ 94373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"answer":"styles_answer__gB1ow","questionContainer":"styles_questionContainer__uAJnF","question":"styles_question__P_gpE","plus":"styles_plus__Ip9eW","minus":"styles_minus__CyVRb","pen-tests-ai":"styles_pen-tests-ai__sAlfG","questionTitle":"styles_questionTitle__Zl1wR","answerWrapper":"styles_answerWrapper__0w4_w"};

/***/ })

}]);